module.exports = __webpack_public_path__ + "static/turkbox-logo-107ec1d55f9e99cf269117c6345de4e0.png";